import StudentsList from './Students-list'
import './teacher.css'
import ProfileHeader from '../ProfileHeader'

export default function Teacher() {
	return (
		<div className='profile_content'>
			<div className='profile_block_cont'>
				<ProfileHeader  organization={true}/>
				<StudentsList/>
			</div>
		</div>
	)
}